import React from "react";
import styled from "styled-components";

const Svg = styled.svg`
  @media (min-width: 575px) {
    display: none;
  }
`;

const MobileFilter = ({ background, ...props }) => {
  return background ? (
    <Svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="14.089"
      viewBox="0 0 20 14.089"
    >
      <g fill="none" stroke="#445ce2" strokeMiterlimit="10">
        <g transform="translate(-19 -150.288)">
          <line x1="6.051" transform="translate(32.949 152.333)" />
          <line x1="10.86" transform="translate(19 152.333)" />
          <path
            d="M32.289,2.045a1.545,1.545,0,1,1-3.089,0,1.545,1.545,0,1,1,3.089,0Z"
            transform="translate(.66 150.288)"
          />
        </g>
        <g transform="translate(-19 -140.288)">
          <line x1="6.051" transform="translate(32.949 152.333)" />
          <line x1="10.86" transform="translate(19 152.333)" />
          <path
            d="M32.289,2.045a1.545,1.545,0,1,1-3.089,0,1.545,1.545,0,1,1,3.089,0Z"
            transform="translate(.66 150.288)"
          />
        </g>
        <g transform="rotate(180 19.5 79.689)">
          <line x1="6.051" transform="translate(32.949 152.333)" />
          <line x1="10.86" transform="translate(19 152.333)" />
          <path
            d="M32.289,2.045a1.545,1.545,0,1,1-3.089,0,1.545,1.545,0,1,1,3.089,0Z"
            transform="translate(.66 150.288)"
          />
        </g>
      </g>
    </Svg>
  ) : (
    <Svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <g>
        <circle cx="15" cy="15" r="15" fill="#2e7074" />
        <g
          transform="translate(4.974 10.288)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
        >
          <line x1="3.751" transform="translate(15.975 2.045)" />
          <line x1="12.886" transform="translate(0 2.045)" />
          <path
            d="M32.289,2.045a1.545,1.545,0,1,1-3.089,0,1.545,1.545,0,1,1,3.089,0Z"
            transform="translate(-16.314)"
          />
          <line x1="3.751" transform="translate(0 8.267)" />
          <line x1="12.886" transform="translate(6.84 8.267)" />
          <path
            d="M11.589,16.145A1.545,1.545,0,1,1,10.045,14.6,1.508,1.508,0,0,1,11.589,16.145Z"
            transform="translate(-4.749 -7.878)"
          />
        </g>
      </g>
    </Svg>
  );
};

export default MobileFilter;
